import { Stack, SxProps } from "@mui/material";
import { ReactNode } from "react";

interface IPageContainer {
  children?: ReactNode;
  sx?: SxProps;
}

export function PageContainer({ children, sx }: IPageContainer) {
  return (
    <Stack
      sx={{
        px: 10,
        maxWidth: 1440,
        minWidth: 720,
        m: "0 auto",
        height: "100%",
        width: "100%",
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
}
